"use client"

import {styled} from "@mui/material/styles";

const Stripe = styled("section")(({theme}) => ({
  width: "100%"
}));

const StripeContent = styled("div")(({theme}) => ({
  maxWidth: "950px",
  margin: "0 auto",
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4)
}));

export {Stripe, StripeContent};
